// RefCapture.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RefCapture() {
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = (params.get("ref") || "").trim();
    if (ref) {
      localStorage.setItem("ref_code", ref);
      document.cookie = `ref=${encodeURIComponent(ref)}; Max-Age=${30 * 24 * 3600}; path=/; SameSite=Lax`;
    }
  }, [location.search]);
  return null;
}
